import { mapperModuleNavigationLink } from '../../../../core/data-layer/modules/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Block partners metadata specs mapper
 * @param {Object} data - cms response data
 * @param {Function} getUrl - cms response data
 * @return {Object} the normalized data
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return {
      partnerName: '',
      location: '',
      languages: [],
      url: '',
      availability: [],
      availabilityLabels: [],
      industries: [],
      products: [],
      partners: [],
      paymentMethods: [],
      terminals: []
    }
  }

  // Special cases for countries. If GLOBAL is present, hide the others
  const availabilityItems = data.availabilityCollection?.items || []
  const globalCountryIndex = availabilityItems.findIndex((i) => i.internalName === 'GLOBAL')
  const availabilityItemsConsideringGlobal =
    globalCountryIndex > -1 ? [availabilityItems[globalCountryIndex]] : availabilityItems

  return {
    partnerName: data.partnerName || '',
    location: data.location ? { id: data.location.sys.id, name: data.location.name } : '',
    languages: data.languagesCollection?.items.filter(Boolean).map((i) => ({ id: i.sys.id, name: i.name })) || [],
    url: data.url,
    availability:
      availabilityItems
        .filter(Boolean)
        .map((i) => ({ id: i.sys.id, name: i.name, isGlobal: i.internalName === 'GLOBAL' })) || [],
    availabilityLabels: availabilityItemsConsideringGlobal?.map((i) => i.name) || [],
    industries:
      data.industriesCollection?.items
        .filter(Boolean)
        .map((i) => ({ id: i.sys.id, name: i.name, link: mapperModuleNavigationLink(i.link, options.getUrl!) })) || [],
    products:
      data.productsCollection?.items
        .filter(Boolean)
        .map((i) => ({ id: i.sys.id, name: i.name, link: mapperModuleNavigationLink(i.link, options.getUrl!) })) || [],
    partners: data.partnersCollection?.items.filter(Boolean).map((i) => ({ id: i.sys.id, name: i.name })) || [],
    paymentMethods:
      data.paymentMethodsCollection?.items
        .filter(Boolean)
        .map((i) => ({ id: i.sys?.id, name: i.paymentMethod?.name })) || [],
    terminals: data.terminalsCollection?.items.filter(Boolean).map((i) => ({ id: i.sys?.id, name: i.name })) || []
  }
}
